import axios from "axios";
import { AvailabilityResponse } from "redmond";
import { apiVersionPrefix } from "../paths";
import { config } from "../../config";

const staysAvailabilityApiPrefix = `${apiVersionPrefix}/stays/availability`;

export interface StaysAvailabilityForListingParams {
  listingId: string;
  fromDate: string;
  untilDate: string;
  adultsCount: number;
  childrenCount: number;
  petsCount: number;
}

export const fetchStaysAvailabilityForListing = (
  params: StaysAvailabilityForListingParams,
): Promise<AvailabilityResponse> => {
  const payload = {
    AvailabilityRequest: "InitialSearch",
    progressiveConfig: {},
    stayDates: { from: params.fromDate, until: params.untilDate },
    guests: {
      adults: params.adultsCount,
      children: new Array(params.childrenCount).fill(10),
      pets: params.petsCount,
    },
    platform: "Desktop",
    lodgingSelection: {
      lodgingIds: [params.listingId],
      preserveOrder: true,
      LodgingSelection: "LodgingIds",
    },
    rooms: { numberOfRooms: 1 },
    lodgingCollection: "NoCollection",
    excludeNonLuxuryLodgings: false,
    searchRefinementOptions: {
      sort: "MostRecommended",
      stayTypes: ["Homes"],
    },
  };

  return axios
    .post(staysAvailabilityApiPrefix, payload, { baseURL: config.baseURL })
    .then((res) => res.data);
};
